module.exports = __webpack_public_path__ + "static/media/Brios-Coconut-Descripcion-Desktop.d8d91424.webp";